import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageTextAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageTextAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V11H15V14H12V20H15V22H4ZM7 5V7H15V5H7ZM7 9V11H11V9H7Z" fill="currentColor"/><Path d="M19 16V13H17V16H14V18H17V21H19V18H22V16H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageTextAdd;
